import React from 'react';
import { Config } from '../../../constants/constant';
import * as Session from '../../../domain/Session';
import * as Pager from '../../../domain/Pager';
import PagerComponent from '../../common/Pager';

/**
 * ページング
 */
interface Props {
  session: Session.Value;
  pager: Pager.Value;
}

const TopicListPagerComponent: React.FC<Props> = props => {
  const { session, pager } = props;
  const categoryCode = pager.filter.get('categoryCode');
  const basePathname = '/topic/list';
  const baseAsPath = categoryCode === 0 ? '/topic/list' : `/topic/list/${categoryCode}`;
  const baseQuery = categoryCode === 0 ? {} : { category_code: categoryCode };
  const nodeNum = session.isSp ? Config.PAGER_NODE_NUM_SP : Config.PAGER_NODE_NUM_PC;

  return <PagerComponent pager={pager} nodeNum={nodeNum} basePathname={basePathname} baseAsPath={baseAsPath} baseQuery={baseQuery} />;
};

export default TopicListPagerComponent;
